import { Box, FormLabel, Radio, RadioGroup, Stack, Text } from "@chakra-ui/react";

export const IncludeExcludeRadio = ({
  value=false,
  onChange,
  ...props
}: {
  value: boolean;
  onChange: (value: string) => void;
  [key: string]: any;
}) => {
  return (
    <RadioGroup
      value={String(value)}
      onChange={(val) => onChange(String(val))}
      {...props}
    >
      <Stack direction="row" spacing={2}>
        <Radio {...props} value="true">Exclude</Radio>
        <Radio {...props} value="false">Include</Radio>
      </Stack>
    </RadioGroup>
  );
};